import Big from "big.js"
import * as z from "zod"

import { createEntityFor } from "@axtesys/react-tools"

export type TaxInfo = {
  taxRate: number
  net: Big
  tax: Big
  gross: Big
  discount: Big
  undiscountedGross: Big
}

export type TotalTaxInfo = Omit<TaxInfo, "taxRate"> & { correctedGross: Big }

export const TaxInfoEntity = createEntityFor<TaxInfo>()
  .withSchema(
    z.object({
      taxRate: z.number(),
      net: z.string(),
      tax: z.string(),
      gross: z.string(),
      discount: z.string(),
      undiscountedGross: z.string(),
    }),
  )
  .serialize(data => ({
    taxRate: data.taxRate,
    net: data.net.toString(),
    tax: data.tax.toString(),
    gross: data.gross.toString(),
    discount: data.discount.toString(),
    undiscountedGross: data.undiscountedGross.toString(),
  }))
  .deserialize(json => ({
    taxRate: json.taxRate,
    net: Big(json.net),
    tax: Big(json.tax),
    gross: Big(json.gross),
    discount: Big(json.discount),
    undiscountedGross: Big(json.undiscountedGross),
  }))

export const TotalTaxInfoEntity = createEntityFor<TotalTaxInfo>()
  .withSchema(
    z.object({
      net: z.string(),
      tax: z.string(),
      gross: z.string(),
      discount: z.string(),
      undiscountedGross: z.string(),
      correctedGross: z.string(),
    }),
  )
  .serialize(data => ({
    net: data.net.toString(),
    tax: data.tax.toString(),
    gross: data.gross.toString(),
    discount: data.discount.toString(),
    undiscountedGross: data.undiscountedGross.toString(),
    correctedGross: data.correctedGross.toString(),
  }))
  .deserialize(json => ({
    net: Big(json.net),
    tax: Big(json.tax),
    gross: Big(json.gross),
    discount: Big(json.discount),
    undiscountedGross: Big(json.undiscountedGross),
    correctedGross: Big(json.correctedGross),
  }))
